import { TwyfordSentry } from '@/core/init'

/**
 * 业务错误处理器
 */
export class BusinessErrorHandler {
  /**
   * 处理 API 错误
   */
  static handleApiError(error: any, apiName: string): void {
    TwyfordSentry.captureError(error, {
      type: 'api_error',
      api_name: apiName,
      status: error.response?.status,
      url: error.config?.url
    })
  }

  /**
   * 处理业务逻辑错误
   */
  static handleBusinessError(
    errorCode: string,
    errorMessage: string,
    extra?: Record<string, any>
  ): void {
    TwyfordSentry.captureMessage(
      `Business Error: [${errorCode}] ${errorMessage}`,
      'warning'
    )

    if (extra) {
      TwyfordSentry.setContext('business_error', {
        error_code: errorCode,
        ...extra
      })
    }
  }

  /**
   * 处理用户操作错误
   */
  static handleUserActionError(
    action: string,
    error: Error,
    userId?: string
  ): void {
    TwyfordSentry.addBreadcrumb({
      category: 'user_action',
      message: `User action failed: ${action}`,
      level: 'error',
      data: { userId }
    })

    TwyfordSentry.captureError(error, {
      type: 'user_action_error',
      action,
      user_id: userId
    })
  }
}
